import { DispositionType } from 'types/call.type';
import axiosInstance from './config/api';

export type CallDispositions = {
    dispositions: DispositionType[];
};

export const getCallDisposition = async () => {
    return axiosInstance.get<CallDispositions>('/calls/dispositions').then((res) => res.data);
};
